import React from 'react';
import Layout from './Layout/Layout'


const User = () => {
    return (
        <div>
            <Layout></Layout>
        </div>
    );
};

export default User;